export const About = () => {
  return (
    <section
      id="sobre-nosotros"
      data-testid="about-section"
      className="relative bg-[#0A0A0A] text-white py-16 sm:py-24 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 -left-20 w-[420px] h-[420px] bg-red-600/10 blur-3xl rounded-full"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-red-600" />
            <span className="text-[11px] uppercase tracking-[0.35em] text-red-500 font-semibold">
              Nuestra Historia
            </span>
          </div>
          <h2 className="font-display uppercase text-5xl sm:text-6xl leading-[0.95] tracking-tighter">
            Más de <br />
            <span className="text-red-600">cuatro décadas</span>
            <br /> de sabor.
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-8 lg:max-w-md">
            {[
              { k: "1985", v: "Año de fundación" },
              { k: "Tradición", v: "Recetas y experiencia" },
              { k: "Servicio", v: "Atención familiar" },
            ].map((stat) => (
              <div
                key={stat.k}
                className="border border-white/10 p-3 sm:p-4 hover:border-red-600 transition-colors"
              >
                <p className="font-display text-2xl sm:text-3xl text-red-500 tracking-tight uppercase">
                  {stat.k}
                </p>
                <p className="text-[10px] sm:text-xs uppercase tracking-widest text-white/60 mt-1">
                  {stat.v}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7 space-y-5 text-white/80 text-base sm:text-lg leading-relaxed">
          <p>
            La historia de{" "}
            <span className="text-white font-semibold">Mariscos Popeye</span> se
            remonta a <span className="text-red-500 font-semibold">1976</span>,
            cuando <span className="text-white">Ricardo Amaya</span>, actual
            propietario del restaurante, comenzó a trabajar a los 8 años de edad
            junto a su hermana mayor en una coctelería de mariscos llamada{" "}
            <em>El Camarón Loco</em>, ubicada en la Avenida Juárez y calle 25.
            Fue ahí donde nació su pasión por los mariscos y donde aprendió los
            fundamentos de un oficio que marcaría el rumbo de su vida.
          </p>
          <p>
            Años más tarde, en{" "}
            <span className="text-red-500 font-semibold">1980</span>, su hermano
            Salvador <em>“Chava”</em> Amaya abrió una marisquería llamada{" "}
            <em>Mariscos Chava</em>. Poco tiempo después, Ricardo Amaya se
            integró al equipo. Para entonces, ambos contaban ya con experiencia
            en el ramo y compartían el sueño de ofrecer mariscos frescos y de
            calidad a las familias chihuahuenses.
          </p>
          <p>
            Después de varios años de trabajo y crecimiento, en{" "}
            <span className="text-red-500 font-semibold">1985</span> Eliseo
            Amaya, junto con su hermano Héctor Amaya, se trasladó a la colonia
            Industrial, ubicación donde el restaurante permanece hasta el día de
            hoy. Fue entonces cuando nació oficialmente{" "}
            <span className="text-white font-semibold">Mariscos Popeye</span>.
          </p>
          <p>
            Meses después, en{" "}
            <span className="text-red-500 font-semibold">1986</span>, Ricardo
            Amaya se incorporó al proyecto y comenzó una nueva etapa dentro de la
            historia del restaurante. Ese mismo año, Eliseo Amaya, hermano mayor
            de Ricardo, emigró a Los Ángeles, California, dejando a Ricardo al
            frente del restaurante.
          </p>
          <p>
            Desde entonces, Ricardo Amaya ha dedicado más de cuatro décadas a
            perfeccionar recetas, crear nuevos platillos y ofrecer una
            experiencia que combina tradición, frescura y sabor. Con
            ingredientes seleccionados diariamente, recetas familiares y una
            sazón única que se reconoce desde la primera cucharada, Mariscos
            Popeye se ha convertido en parte de la historia gastronómica de
            Chihuahua.
          </p>
          <p className="text-white">
            Hoy, más de 40 años después, seguimos compartiendo la misma pasión
            que inició en 1976:{" "}
            <span className="text-red-500 font-semibold">
              servir mariscos de calidad con el sabor, la tradición y el
              servicio que nos distinguen.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};
